import React, {useEffect, useMemo, useState} from "react";

import {format} from "d3-format";
import {timeFormat} from "d3-time-format";
import {getGraph, setActiveTimeframe} from "../../store/actions/graphActions";
import {timeFrom, timeTo} from "../../utils/timeInterval";

import {Chart} from "react-stockcharts";
import ChartCanvas from "./chartCanvas.jsx";
import {BarSeries,} from "react-stockcharts/lib/series";
import {XAxis, YAxis} from "react-stockcharts/lib/axes";
import {CrossHairCursor, MouseCoordinateX, MouseCoordinateY,} from "react-stockcharts/lib/coordinates";
import {discontinuousTimeScaleProvider} from "react-stockcharts/lib/scale";
import {last} from "react-stockcharts/lib/utils";

import OrdersCandlesSeries from "./ordersCandlesSeries.jsx";
import BorderFilter from "./borderFilter.jsx";
import ZoomButtonsComponent from "./zoomButtons.jsx";
import {useDispatch, useSelector} from "react-redux";
import {setTimeFrom, setTimeTo, setPriceFrom, setPriceTo, setShowCanceledOrders, setShowBrushFilter} from "../../store/actions/settingsActions";
import {formatDbDate, moment} from "../../config";
import {translateOptions} from "../../config";

function FullChart(props) {

    // Импорт диспатчера
    const dispatch = useDispatch();
    const timeframes = useSelector(state => state.graph.timeframes);
    const activeTimeframe = useSelector(state => state.graph.activeTimeframe);

    // const storeShowCanceledOrders = useSelector(state => state.settings.showCanceledOrders);
    // const storeShowBrushFilter = useSelector(state => state.settings.showBrushFilter);

    // Дефолтные переменные для графика
    const {type, data: initialData, height, width, ratio} = props;
    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
        d => d.date
    );

    const {data, xScale, xAccessor, displayXAccessor} = xScaleProvider(
        initialData
    );
    const start = xAccessor(last(data));
    const end = xAccessor(data[Math.max(0, data.length - 150)]);
    const xExtents = [start, end];

    // Цвета графика
    let axisColor = 'rgba(255,255,255,.7)';
    let fillColor = 'rgba(255,255,255,.2)';
    let greenMain = 'rgba(51,188,51,1)';
    let greenNatural = 'rgba(51,188,51,.2)';
    let redMain = 'rgba(255,0,0,1)';
    let redNatural = 'rgba(255,0,0,.2)';
    let buyCloseOrderColor = 'rgba(102,255,16,1)';
    let buyCloseOrderBorderColor = 'rgba(102,255,16,1)';
    let sellCloseOrderColor = 'rgba(255,53,2,1)';
    let sellCloseOrderBorderColor = 'rgba(255,53,2,1)';
    let buyOpenOrderColor = 'rgba(0,162,0,1)';
    let buyOpenOrderBorderColor = 'rgba(0,162,0,1)';
    let sellOpenOrderColor = 'rgba(254,39,16,1)';
    let sellOpenOrderBorderColor = 'rgba(254,39,16,1)';

    // Высота граифка
    let chartHeight = height - 40;

    // Переменная для состояния визуального фильтра ордеров
    // const [filterState, updateFilterState] = useState(storeShowBrushFilter);
    const [filterState, updateFilterState] = useState(false);

    // Переменная для состояния показа закрытых ордеров
    const [showClosedOrders, updateShowClosedOrders] = useState(true);

    // Переменная для состояния показа открытых ордеров
    const [showOpenedOrders, updateShowOpenedOrders] = useState(true);

    // Переменная для состояния показа открытых ордеров
    // const [showCanceledOrders, updateShowCanceledOrders] = useState(storeShowCanceledOrders);
    const [showCanceledOrders, updateShowCanceledOrders] = useState(false);

    function ToggleFilterState() {
        if (window.demoChartPage) {
            return '';
        }

        if (filterState) {
            return <div
                className={'chart__settings-item chart__settings-item--active'}
                onClick={HandlerToggleFilterState}

            >
                {translateOptions.graphFilterButtonOff}
            </div>;
        } else {
            return <div
                className={'chart__settings-item'}
                onClick={HandlerToggleFilterState}

            >
                {translateOptions.graphFilterButtonOn}
            </div>;
        }
    }

    function HandlerToggleFilterState() {
        updateFilterState(!filterState);
    }

    function ToggleShowClosedOrders() {

        if (showClosedOrders) {
            return <div
                className={'chart__settings-item chart__settings-item--active'}
                onClick={HandlerToggleShowClosedOrders}
            >
                Скрыть закрытые&nbsp;ордера
            </div>;
        } else {
            return <div
                className={'chart__settings-item'}
                onClick={HandlerToggleShowClosedOrders}
            >
                Показать закрытые&nbsp;ордера
            </div>;
        }
    }

    function HandlerToggleShowClosedOrders() {
        updateShowClosedOrders(!showClosedOrders);
    }

    function ToggleShowOpenedOrders() {

        if (showOpenedOrders) {
            return <div
                className={'chart__settings-item chart__settings-item--active'}
                onClick={HandlerToggleShowOpenedOrders}
            >
                {translateOptions.graphOpenButtonHide}
            </div>;
        } else {
            return <div
                className={'chart__settings-item'}
                onClick={HandlerToggleShowOpenedOrders}
            >
                {translateOptions.graphOpenButtonShow}
            </div>;
        }
    }

    function ToggleShowCanceledOrders() {

        if (showCanceledOrders) {
            return <div
                className={'chart__settings-item chart__settings-item--active'}
                onClick={HandlerToggleShowCanceledOrders}
            >
                {translateOptions.graphCancelButtonHide}
            </div>;
        } else {
            return <div
                className={'chart__settings-item'}
                onClick={HandlerToggleShowCanceledOrders}
            >
                {translateOptions.graphCancelButtonShow}
            </div>;
        }
    }

    function HandlerToggleShowOpenedOrders() {
        updateShowOpenedOrders(!showOpenedOrders);
    }

    function HandlerToggleShowCanceledOrders() {
        updateShowCanceledOrders(!showCanceledOrders);
    }

    function Timeframes() {
        if (timeframes.length === 0) {
            return;
        }

        const timeframesMap = timeframes.map(timeframe => {
            if (timeframe === activeTimeframe) {
                return <div key={timeframe} className={'chart__settings-item chart__settings-item--active'}>{timeframe}</div>;
            } else {
                return <div key={timeframe} onClick={() => dispatch(setActiveTimeframe(timeframe))} className={'chart__settings-item'}>{timeframe}</div>;
            }
        });

        return <div className={'chart__settings-items'}>
            {timeframesMap}
        </div>;
    }

    function handleBrush(brushCoords) {
        let fromTime = +brushCoords.start.item.open_time;
        let toTime = +brushCoords.end.item.open_time;
        let fromPrice = brushCoords.end.yValue;
        let toPrice = brushCoords.start.yValue;

        let resultFromTime = fromTime;
        let resultToTime = toTime;
        let resultFromPrice = fromPrice;
        let resultToPrice = toPrice;

        if (fromTime > toTime) {
            resultFromTime = toTime;
            resultToTime = fromTime;
        }

        if (fromPrice > toPrice) {
            resultFromPrice = toPrice;
            resultToPrice = fromPrice;
        }

        resultFromPrice = resultFromPrice.toFixed(2);
        resultToPrice = resultToPrice.toFixed(2);

        dispatch(setTimeFrom(new Date(+resultFromTime)));
        dispatch(setTimeTo(new Date(+resultToTime)));
        dispatch(setPriceFrom(resultFromPrice));
        dispatch(setPriceTo(resultToPrice));
    }

    let settingsClass = 'chart__settings';
    let settingsButtonsClass = 'chart__settings-buttons';

    if (window.demoChartPage) {
        settingsClass = 'chart__settings chart__settings--demo';
        settingsButtonsClass = 'chart__settings-buttons chart__settings-buttons--demo';
    }

    return (
        <div>
            <ChartCanvas
                height={height}
                ratio={ratio}
                width={width}
                margin={{left: 20, right: 70, top: 10, bottom: 30}}
                type={type}
                seriesName="BTCUSDT"
                data={data}
                xScale={xScale}
                xAccessor={xAccessor}
                displayXAccessor={displayXAccessor}
                xExtents={xExtents}

                zoomEvent={false}
                mouseMoveEvent={true}
                panEvent={true}
            >

                <Chart
                    id={2}
                    height={chartHeight - 400}
                    yExtents={d => d.volume}
                    origin={(w, h) => [0, 400]}
                >
                    <MouseCoordinateX
                        at="bottom"
                        orient="bottom"
                        displayFormat={timeFormat("%d.%m.%Y %H:%M")}
                    />

                    <BarSeries
                        yAccessor={d => d.volume}
                        fill={d => (d.close > d.open ? greenNatural : redNatural)}
                    />

                    <XAxis axisAt="top" orient="top" stroke={axisColor} tickStroke={axisColor} tickFormat={item => {

                        return moment(data[item].open_time).format('HH:mm');
                    }}/>
                    <XAxis axisAt="bottom" orient="bottom" stroke={axisColor} tickStroke={axisColor} tickFormat={item => {

                        return moment(data[item].open_time).format('HH:mm');
                    }}/>

                    <YAxis axisAt="right" orient="right" ticks={10} tickStroke={axisColor}/>
                </Chart>

                <Chart
                    id={1}
                    height={chartHeight - (chartHeight - 370)}
                    yExtents={[d => [d.high, d.low]]}
                >
                    <YAxis axisAt="right" orient="right" ticks={10} tickStroke={axisColor}/>

                    <MouseCoordinateY
                        at="right"
                        orient="right"
                        displayFormat={format(".2f")}
                    />

                    <OrdersCandlesSeries
                        stroke={d => (d.close > d.open ? greenMain : redMain)}
                        openOrders={props.openOrders}
                        showClosedOrders={showClosedOrders}
                        showOpenedOrders={showOpenedOrders}
                        showCanceledOrders={showCanceledOrders}
                        buyCloseOrderColor={buyCloseOrderColor}
                        buyCloseOrderBorderColor={buyCloseOrderBorderColor}
                        sellCloseOrderColor={sellCloseOrderColor}
                        sellCloseOrderBorderColor={sellCloseOrderBorderColor}
                        buyOpenOrderColor={buyOpenOrderColor}
                        buyOpenOrderBorderColor={buyOpenOrderBorderColor}
                        sellOpenOrderColor={sellOpenOrderColor}
                        sellOpenOrderBorderColor={sellOpenOrderBorderColor}
                    />

                    <BorderFilter
                        enabled={filterState}
                        type={'2D'}
                        onBrush={handleBrush}
                        handler={handleBrush}
                        stroke={axisColor}
                        fill={fillColor}
                    />

                    <ZoomButtonsComponent/>
                </Chart>

                <CrossHairCursor
                    stroke={axisColor}
                    stroke-width={1}
                />
            </ChartCanvas>

            <div className={settingsClass}>
                <Timeframes/>

                <div className={settingsButtonsClass}>
                    <ToggleShowCanceledOrders/>
                    <ToggleShowOpenedOrders/>
                    <ToggleFilterState/>
                </div>
            </div>
        </div>
    );
}


export default FullChart;
